import React from 'react';
import { Box } from '@mui/material';

import partnerImg from '../../data/images/partners.png';
import partnerImg_mobile from '../../data/images/partner_mobile.png';

type Props = {}

const Partners = (props: Props) => {

  const webWidth = window.innerWidth;

  return (
    <>
      <Box 
        sx={{ 
          width: '100%', 
          height: 'auto', 
          // border: '1px solid black',
          // backgroundColor: 'black',
          p: 0,
          mt: '8em',
          mb: '3em'
          }}>
        {
              webWidth > 1300
              ?
              <img src={partnerImg} width={'100%'} />
              :
              <img src={partnerImg_mobile} width={'100%'} />
          }
      </Box>
    </>
  )
}

export default Partners